const API_URL = process.env.REACT_APP_API_URL;

export type InitializeRegisterErrorCode = 'INVALID_EMAIL' | 'EMAIL_ALREADY_IN_USE';

export class ApiError extends Error {
  constructor(public readonly code: string, message: string) {
    super(message);
  }
}

export const requestRegistration = async (email: string): Promise<void> => {
  const response = await fetch(`${API_URL}/api/users/initializeRegister`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new ApiError(body?.errorCode ?? 'UNKNOWN', body?.message ?? response.statusText);
  }
};

export type RegisterUserViolation =
  | 'EMAIL_NOT_UNIQUE'
  | 'EMAIL_INVALID'
  | 'EMAIL_EMPTY'
  | 'PASSWORD_EMPTY'
  | 'PASSWORD_TOO_SHORT'
  | 'PASSWORD_TOO_LONG'
  | 'PASSWORD_CONTAINS_WHITESPACE'
  | 'FIRST_NAME_EMPTY'
  | 'FIRST_NAME_TOO_SHORT'
  | 'FIRST_NAME_TOO_LONG'
  | 'LAST_NAME_EMPTY'
  | 'LAST_NAME_TOO_SHORT'
  | 'LAST_NAME_TOO_LONG'
  | 'ROLE_EMPTY';

export class RegisterValidationError extends Error {
  constructor(public readonly violations: RegisterUserViolation[]) {
    super('input data is invalid');
  }
}

export interface RegisterUserRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}

export const registerUser = async (request: RegisterUserRequest, jwtToken: string): Promise<void> => {
  const response = await fetch(`${API_URL}/api/users/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${jwtToken}`,
    },
    body: JSON.stringify(request),
  });
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    const violations: RegisterUserViolation[] = (body?.violations ?? []).map(
      (v: { violation: RegisterUserViolation }) => v.violation,
    );
    throw new RegisterValidationError(violations);
  }
};

export const login = async (email: string, password: string): Promise<{ jwtToken: string }> => {
  const response = await fetch(`${API_URL}/api/authentication/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new ApiError(body?.errorCode ?? 'UNKNOWN', body?.message ?? response.statusText);
  }
  return response.json();
};
